import { ReactComponent as Logo } from './logo.svg';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import ScrollToTop from './Components/ScrollToTop.js';
import useScrollTopClass from "./Components/ScrollOnTop.js";
import './App.css';
import Menu from './Components/Menu.js';
import Home from './Pages/Home.js';
import Terminos from './Pages/Terminos.js';
import Seguridad from './Pages/Seguridad.js';
import Cookies from './Pages/Cookies.js';
import AboutUs from './Pages/AboutUs.js';
import MoreWorks from './Pages/MoreWorks.js';
import Mshops from './Pages/Mshops.js';
import TiendaNube from './Pages/TiendaNube.js';
import ServicesPage from './Pages/ServicesPage.js';
import BrandsPage from './Pages/BrandsPage.js';
import ContactPage from './Pages/ContactPage.js';
import Footer from './Components/Footer.js';
import Application from './Pages/Application.js';
import Wrapped25 from './Pages/Wrapped25.js';


const pageVariants = {
  initial: { opacity: 0, x: -50 },
  animate: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  exit: { opacity: 0, x: 50, transition: { duration: 0.5 } }
};

const PageWrapper = ({ children }) => (
  <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
    {children}
  </motion.div>
);

function AnimatedRoutes() {
  const location = useLocation();

  useEffect(() => {
    const pageClass = location.pathname.replace("/", "") || "home";
    document.body.className = `page-${pageClass}`;
    
    return () => {
      document.body.className = "";
    };
  }, [location]);
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/home" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/terminos" element={<PageWrapper><Terminos /><Footer/></PageWrapper>} />
        <Route path="/seguridad" element={<PageWrapper><Seguridad /><Footer/></PageWrapper>} />
        <Route path="/cookies" element={<PageWrapper><Cookies /><Footer/></PageWrapper>} />
        <Route path="/aboutus" element={<PageWrapper><AboutUs /><Footer/></PageWrapper>} />
        <Route path="/works" element={<PageWrapper><MoreWorks /><Footer/></PageWrapper>} />
        <Route path="/mshops" element={<PageWrapper><Mshops /><Footer/></PageWrapper>} />
        <Route path="/tiendanube" element={<PageWrapper><TiendaNube /><Footer/></PageWrapper>} />
        <Route path="/services" element={<PageWrapper><ServicesPage /><Footer/></PageWrapper>} />
        <Route path="/clients" element={<PageWrapper><BrandsPage /><Footer/></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><ContactPage /><Footer/></PageWrapper>} />
        <Route path="/applications" element={<PageWrapper><Application /><Footer/></PageWrapper>} />
        <Route path="/wrapped25" element={<PageWrapper><Wrapped25 /><Footer/></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  useScrollTopClass();
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <header className="App-header">
          <a className='logoIndex' href="/" aria-label="Ir al inicio"><Logo className="App-logo" /></a>
          <Menu />
        </header>
        <AnimatedRoutes />
       
      </div>
    </Router>
  );
}

export default App;